import React from 'react'
import styled from 'styled-components'
import { Box, muiBankTheme, Icon, Space, TextBody } from '@ally/metronome-ui'
import { muiInsights } from '@ally/metronome-icons'
import { LoadState } from '@ally/use-data-domain'
import LoadingSpinner from '../LoadingSpinner'
import { InvestWidgetContent } from '../../../types'

const StyledUL = styled.ul`
  margin-bottom: 0px;
  padding-left: 28px;
`

const WidgetBody: React.FC<{
  data: InvestWidgetContent
  loadingState: LoadState
}> = ({ data, loadingState }): React.ReactElement => {
  const {
    contentTitle,
    contentBody,
    listTitle,
    listIconAriaLabel,
    listItems,
  } = data
  const showKeyTakeaways = listTitle && listItems && listItems.length > 0

  switch (loadingState) {
    case LoadState.LOADING:
      return <LoadingSpinner />
    case LoadState.LOADED:
    default:
      return (
        <>
          {(contentTitle || contentBody) && (
            <Box
              backgroundColor={muiBankTheme.colors['light-gray']}
              borderBottom="1px solid"
              borderColor="gray-300"
              mt="-8px"
              mx="-8px"
              mb={showKeyTakeaways ? '0' : '-8px'}
              py="sm"
              px="xs"
            >
              {contentTitle && (
                <Space mb="sm">
                  <TextBody tag="p" size="sm" weight="bold">
                    {contentTitle}
                  </TextBody>
                </Space>
              )}
              {contentBody && (
                <TextBody tag="p" size="sm">
                  {contentBody}
                </TextBody>
              )}
            </Box>
          )}
          {showKeyTakeaways && (
            <Box pt="sm" pb="xs">
              {listTitle && (
                <Box display="flex" alignItems="center">
                  <Space mr="sm">
                    <Icon
                      icon={muiInsights}
                      unsupportedCustomWidth={36}
                      unsupportedCustomHeight={36}
                      aria-label={listIconAriaLabel}
                      ariaHidden={!!listIconAriaLabel}
                    />
                  </Space>
                  <TextBody tag="p" size="sm" weight="bold">
                    {listTitle}
                  </TextBody>
                </Box>
              )}
              {Array.isArray(listItems) && (
                <StyledUL>
                  {listItems.map(item => {
                    return <li>{item}</li>
                  })}
                </StyledUL>
              )}
            </Box>
          )}
        </>
      )
  }
}

export default WidgetBody
